module.exports = __webpack_public_path__ + "media/application/images/svgs/italic-80e653d77320c058818b03cd4b0dedc7.svg";